import { publicInstance } from 'api/axios';
import { usersV2 } from 'api/users/usersApi';
import { LoginResponseType } from 'api/users/login';

export interface activateUserPayloadType {
	activationToken: string;
	email: string;
	password: string;
}

function activateUser(payload: activateUserPayloadType) {
	return publicInstance
		.patch<LoginResponseType>('activate', payload, {
			baseURL: usersV2,
		})
		.then((res) => res.data);
}

export default activateUser;
